import { withTranslation } from 'react-i18next';
import PageSwitcher from './PageSwitcher';

export default withTranslation()(PageSwitcher);
